import { CONFERENCE_WORKSPACE_ROUTE_BASE } from './conferenceWorkspaceConfig';

function workspaceBase(conferenceId) {
    return `${CONFERENCE_WORKSPACE_ROUTE_BASE}/${conferenceId}`;
}

/** 项目信息（编辑会议项目） @returns {string} */
export function workspaceConferenceInfoPath(conferenceId) {
    return workspaceBase(conferenceId);
}

/** 网站模块 @returns {string} */
export function workspaceConferenceSiteModulesPath(conferenceId) {
    return `${workspaceBase(conferenceId)}/site-modules`;
}

/** 日程管理 @returns {string} */
export function workspaceConferenceAgendasPath(conferenceId) {
    return `${workspaceBase(conferenceId)}/agendas`;
}

/** 嘉宾管理 @returns {string} */
export function workspaceConferenceGuestsPath(conferenceId) {
    return `${workspaceBase(conferenceId)}/guests`;
}

/** 直播管理 @returns {string} */
export function workspaceConferenceLivesPath(conferenceId) {
    return `${workspaceBase(conferenceId)}/lives`;
}

/** 报名签到 @returns {string} */
export function workspaceConferenceSignupPath(conferenceId) {
    return `${workspaceBase(conferenceId)}/signup`;
}

/** 机构管理 @returns {string} */
export function workspaceConferenceOrganizationsPath(conferenceId) {
    return `${workspaceBase(conferenceId)}/organizations`;
}

/** 劳务费管理 @returns {string} */
export function workspaceConferenceLaborfeePath(conferenceId) {
    return `${workspaceBase(conferenceId)}/laborfee`;
}

/** 专家价值（专家综评） @returns {string} */
export function workspaceConferenceEvaluationPath(conferenceId) {
    return `${workspaceBase(conferenceId)}/evaluation`;
}

/** 直播-新增 @returns {string} */
export function workspaceConferenceLiveNewPath(conferenceId) {
    return `${workspaceBase(conferenceId)}/lives/new`;
}

/** 直播-编辑 @returns {string} */
export function workspaceConferenceLiveEditPath(conferenceId, liveId) {
    return `${workspaceBase(conferenceId)}/lives/${liveId}`;
}

/** 直播-观看限制 @returns {string} */
export function workspaceConferenceLiveLimitPath(conferenceId, liveId) {
    return `${workspaceBase(conferenceId)}/lives/${liveId}/limit`;
}

/** 直播-白名单 @returns {string} */
export function workspaceConferenceLiveWhitelistPath(conferenceId, liveId) {
    return `${workspaceBase(conferenceId)}/lives/${liveId}/whitelist`;
}

/** 直播-回放 @returns {string} */
export function workspaceConferenceLiveReplaysPath(conferenceId, liveId) {
    return `${workspaceBase(conferenceId)}/lives/${liveId}/replays`;
}

/** 直播-评论 @returns {string} */
export function workspaceConferenceLiveCommentsPath(conferenceId, liveId) {
    return `${workspaceBase(conferenceId)}/lives/${liveId}/comments`;
}

/** 直播-预约报名数据 @returns {string} */
export function workspaceConferenceLiveSignUpDataPath(conferenceId, liveId) {
    return `${workspaceBase(conferenceId)}/lives/${liveId}/signup-data`;
}

/** 嘉宾行程 @returns {string} */
export function workspaceConferenceGuestJourneysPath(conferenceId) {
    return `${workspaceBase(conferenceId)}/guests/journeys`;
}

/** 报名模板-新增 @returns {string} */
export function workspaceConferenceSignUpTemplateAddPath(conferenceId) {
    return `${workspaceBase(conferenceId)}/signup-template/add`;
}

/** 报名模板-编辑 @returns {string} */
export function workspaceConferenceSignUpTemplateEditPath(conferenceId, templateId) {
    return `${workspaceBase(conferenceId)}/signup-template/${templateId}/edit`;
}
